import { pswFeedbackErrors } from '@/constants';
import type { IPswFeedbackErrorMessage } from '@/types';
import type { ProgressProps } from '@chakra-ui/react';
import { useMemo } from 'react';
import type { MultipleFieldErrors, ValidateResult } from 'react-hook-form';

type GetPasswordErrorMessageColorFn = (error: ValidateResult | undefined) => string;
type GetPasswordProgressPropsFn = (
  value: string,
  types: MultipleFieldErrors | undefined
) => ProgressProps;

export const getPasswordErrorMessageColor: GetPasswordErrorMessageColorFn = (error) =>
  error ? 'inherit' : 'brand.green';

export const getPasswordProgressProps: GetPasswordProgressPropsFn = (value, types) => {
  if (!types)
    return {
      variant: !value ? '' : 'success',
      value: !value ? 10 : 100,
    };

  const errors = Object.keys(types).length;

  return {
    variant: errors === 1 ? 'warning' : '',
    value: !value ? 0 : errors >= 4 ? 10 : errors === 2 ? 50 : errors === 3 ? 25 : 75,
  };
};

interface IUsePasswordFeedbackReturnValue {
  errors: IPswFeedbackErrorMessage[];
  getMessageColor: GetPasswordErrorMessageColorFn;
  getProgressProps: GetPasswordProgressPropsFn;
}

export const usePasswordFeedback = (): IUsePasswordFeedbackReturnValue => {
  return useMemo(
    () => ({
      errors: pswFeedbackErrors,
      getMessageColor: getPasswordErrorMessageColor,
      getProgressProps: getPasswordProgressProps,
    }),
    []
  );
};
